import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  get,
} from 'lodash';
import {
  API,
  GlobalActions,
  NavigationHelper,
  TableBaselines,
  VibeButton,
  viAdd,
  withRouter,
} from 'vibeguide';
import BaselineSidebar from '../../../../Programs/Baselines/Sidebar/BaselineSidebar';
import './Baselines.scss';

class Baselines extends PureComponent {
  constructor(props) {
    super(props);

    this.sidebarTimeout = null;
  }

  componentDidMount() {
    const qs = NavigationHelper.getParams();
    const isNew = qs.type === 'new';
    const isView = qs.baselineId && qs.type !== 'new';

    if (isNew || isView) {
      this.sidebarTimeout = setTimeout(() => {
        this.sidebar(qs.type, qs.baselineId);
      }, 1500);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      location: {
        search,
      },
    } = this.props;

    const {
      location: {
        search: prevSearch,
      },
    } = prevProps;

    if (search !== prevSearch) {
      const qs = NavigationHelper.getParams();

      if (qs.baselineId || qs.type === 'new') {
        this.sidebar(qs.type, qs.baselineId);
      }
    }
  }

  componentWillUnmount() {
    clearTimeout(this.sidebarTimeout);
  }

  /**
   * When the sidebar is closed
   */
  onCloseSidebar = () => {
    const {
      history,
    } = this.props;

    const url = NavigationHelper.updateParams({
      baselineId: null,
      type: null,
    }, {
      keepPage: true,
    });

    history(url);
  };

  /**
   * Determine whether or not to show or hide the sidebar
   */
  sidebar = (type, baselineId = null) => {
    const {
      currentLocation,
      setPanel,
    } = this.props;

    setPanel({
      show: true,
      backdrop: type === 'new',
      children: (
        <BaselineSidebar
          baselineId={baselineId}
          isNew={type === 'new'}
          mediaFormat={currentLocation.mediaFormat}
        />
      ),
      onClose: this.onCloseSidebar,
    });
  };

  render() {
    const {
      currentLocation,
      user,
    } = this.props;

    const locationId = get(currentLocation, '_id', null);

    return (
      <div className="Baselines">
        <TableBaselines
          columns={[
            '.',
            'Name',
            'Company',
            'Description',
            'Locations',
            'Modified',
            'Tags',
            '...',
          ]}
          fetch={API.Location.listBaselines}
          fetchProps={{
            filters: {
              _id: locationId,
            },
          }}
          filters={{
            mediaFormat: currentLocation.mediaFormat,
          }}
          defaultSortBy={{
            label: 'Name',
            attr: 'name',
            direction: 'asc',
          }}
          paginator
          paginatorProps={{
            label: 'Baselines',
            urlPaging: true,
            urlFilters: true,
          }}
          toggle
          toggleProps={{
            label: 'Show Archived Baselines',
            tooltip: true,
          }}
          bulk
          bulkProps={{
            edit: false,
            add: false,
            block: false,
            remove: false,
            archive: true,
          }}
          rowLink={{
            baselineId: '_id',
          }}
          menuItems={[
            { name: 'Archive', userCan: 'baseline.delete' },
          ]}
          toolbarProps={{
            customButtons: user.can('baseline.create')
              ? [
                (
                  <VibeButton
                    key="button-new-baseline"
                    text="New Baseline"
                    color="primary"
                    icon={viAdd}
                    tooltip="New Baseline"
                    tooltipProps={{
                      placement: 'top',
                    }}
                    link={NavigationHelper.updateParams({
                      type: 'new',
                    })}
                  />
                ),
              ]
              : [],
          }}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
    currentLocation: state.locations.currentLocation,
  };
}

const mapDispatchToProps = {
  setPanel: GlobalActions.setPanel,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Baselines));
